import { isCancelledPersonalDataConsentError } from "../errors/PersonalDataConsentError";
import { platformApi } from "../platform";
import { CommonTrackingEvents, rudderAnalytics } from "../rudderstack";

export const updatePersonalData = async () => {
  try {
    await platformApi.updatePersonalData();

    return true;
  } catch (error) {
    if (isCancelledPersonalDataConsentError(error)) {
      rudderAnalytics.track(CommonTrackingEvents.USER_REJECTED_CONSENT, {
        scope: "personal_information",
      });

      return false;
    }

    throw error;
  }
};
